import styled from 'styled-components';
import { Button } from '../../input/Button';
import { SubcategoryProps } from './types';

export const Subcategory = styled(Button)
    .withConfig({ displayName: 'Subcategories' })
    .attrs<SubcategoryProps>((props) => ({
        role: 'tab',
        variant: 'filled',
        color: 'secondary',
        ...props,
    }))<SubcategoryProps>`

    &:not([aria-selected='true']) {
        background-color: transparent;
    }
`;
